import Model from '@/models/Model.js';
import TermScheduleTemplatePeriodCourseTemplate from '@/models/TermScheduleTemplatePeriodCourseTemplate.js';
import TermTemplate from '@/models/term-template/TermTemplate.js';

export default class TermScheduleTemplatePeriod extends Model {
    static entity = 'term_schedule_template_periods';

    static modelName = 'TermScheduleTemplatePeriod';

    static fields() {
        return {
            id: this.attr(null),
            term_schedule_template_id: this.attr(null),
            uuid: this.attr(null),
            title: this.attr(null),
            weeks: this.attr(null),
            order: this.attr(null),
            period_order: this.attr(null),
            type: this.attr(null),

            ...super.fields(),

            term_template: this.belongsTo(TermTemplate, 'term_schedule_template_id'),
            courses: this.hasMany(TermScheduleTemplatePeriodCourseTemplate, 'term_schedule_template_id'),
        };
    }
}
